import React from 'react';

import type {BaseHeaderProps} from '../../components/BaseHeader';

import BaseHeader from '../../components/BaseHeader';
import MobileMenuDrawer from './MobileMenuDrawer';
import useNavLinks from './useNavLinks';

export const mobileMenuDrawer: BaseHeaderProps['mobileMenuDrawer'] = ({
  onCloseClick,
}) => <MobileMenuDrawer onCloseClick={onCloseClick} />;

const Header = () => {
  const navLinks = useNavLinks();

  return (
    <BaseHeader
      mobileMenuDrawer={mobileMenuDrawer}
      navLinks={navLinks}
      showViewerActions={true}
    />
  );
};

export default Header;
